import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ListPerformanceQueryKeys } from '@p/a/r/lp/hooks/queries/query-keys';

import { IListPerformance } from '@t/api/bluebook/client-return/list-performance.model';
import { IResult } from '@t/api/common/operation-results/success-result.model';
import { ListPerformanceParameters } from '@t/api/list-performance/list-performance-parameters.model';

import { listPerformanceService } from 'services/list-performance.service';

export const useFetchListPerformance = (parameters: ListPerformanceParameters) => {
  return useQuery({
    queryFn: async () => {
      return await listPerformanceService.getListPerformance(parameters);
    },
    queryKey: [ListPerformanceQueryKeys.all, parameters],
  });
};

export const createListPerformanceQuery = (
  parameters?: ListPerformanceParameters
): UseQueryOptions<IResult<IListPerformance[]> | undefined, unknown, IListPerformance[] | undefined> => {
  return {
    placeholderData: keepPreviousData,
    queryFn: async () => await listPerformanceService.getListPerformance(parameters ?? {}),
    queryKey: ['lp', parameters],
  };
};
